import { Icon } from "@/components/icons/Icon";
import { useActionKey } from "@/utils/hooks/use-action-key";
import { cx } from "@/utils/classnames";
import React from "react";

export const SearchButton: React.FC = () => {
  const actionKey = useActionKey();
  return (
    <div
      className={cx(
        "flex items-center gap-2",
        "py-1 px-3 rounded-md mr-2",
        "text-zinc-400 text-cds-sm cursor-pointer select-none",
        "hover:bg-cds-light-gray-100 hover:text-zinc-400",
        "active:bg-cds-light-gray-300 active:text-zinc-500",
      )}
      onClick={() => {
        document.dispatchEvent(
          new KeyboardEvent("keydown", {
            key: "k",
            metaKey: true,
          }),
        );
      }}
    >
      <Icon name={"search"} className={"text-cds-gray-400"} />
      <div className={"flex items-baseline gap-1"}>
        <span>Search...</span>
        {/* <CmdIcon className={"w-3 h-3 fill-zinc-400"} /> */}
        <div className={"flex items-baseline text-xs"}>
          <span>{actionKey[0]}</span>
          <span>K</span>
        </div>
      </div>
    </div>
  );
};
